import axios from "axios";
import "./axiosHeaders";

// Download screens use the HTTP status to show their existing missing-file UI.
// Authentication failures must still reject so the shared interceptor can handle them.
export const acceptDownloadResponse = status => status !== 401 && status !== 403;

export default axios;
